var c = Object.defineProperty;
var h = (o, e, r) => e in o ? c(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r;
var l = (o, e, r) => h(o, typeof e != "symbol" ? e + "" : e, r);
import { CONFIG as f } from "@packages/config";
import { window as u } from "@packages/global";
import { Injectable as a, Inject as L } from "@webmotors/ioc";
import { LOGGER as d } from "./main75.js";
var v = Object.getOwnPropertyDescriptor, w = (o, e, r, t) => {
  for (var n = t > 1 ? void 0 : t ? v(e, r) : e, i = o.length - 1, g; i >= 0; i--)
    (g = o[i]) && (n = g(n) || n);
  return n;
}, _ = (o, e) => (r, t) => e(r, t, o);
let s = class {
  constructor(o, e = "GLOBAL") {
    l(this, "level");
    this.config = o, this.context = e;
    const r = (process.env.LOG_LEVEL || "").trim().toLowerCase();
    this.level = ["error", "warn", "info", "log", "debug"].includes(r) ? r : "warn";
  }
  shouldLog(o) {
    var r;
    if (((r = u) == null ? void 0 : r.__ENABLE_LOGGING__) === !0)
      return !0;
    const e = ["error", "warn", "info", "log", "debug"];
    return e.indexOf(o) <= e.indexOf(this.level);
  }
  /**
   * Create a new logger with context
   *
   * @param context
   */
  create(o) {
    return new s(this.config, o);
  }
  /**
   * Writes a log message
   *
   * @param messages
   * @returns
   */
  log(...o) {
    !this.config.logging || !this.shouldLog("log") || console.log(`[${this.context}]`, ...o);
  }
  /**
   * Writes a info message
   *
   * @param messages
   * @returns
   */
  info(...o) {
    !this.config.logging || !this.shouldLog("info") || console.info(`[${this.context}]`, ...o);
  }
  /**
   * Writes a warn message
   *
   * @param messages
   * @returns
   */
  warn(...o) {
    !this.config.logging || !this.shouldLog("warn") || console.warn(`[${this.context}]`, ...o);
  }
  /**
   * Writes a debug message
   *
   * @param messages
   * @returns
   */
  debug(...o) {
    !this.config.logging || !this.shouldLog("debug") || console.debug(`[${this.context}]`, ...o);
  }
  /**
   * Writes a error message
   *
   * @param messages
   * @returns
   */
  error(...o) {
    !this.config.logging || !this.shouldLog("error") || console.error(`[${this.context}]`, ...o);
  }
};
s = w([
  a(d),
  _(0, L(f))
], s);
export {
  s as ConsoleService
};
